import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useAuth } from '../../context/AuthContext';

interface AuthInitializerProps {
  children: React.ReactNode;
}

const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    let mounted = true;
    
    setTimeout(() => {
      if (mounted) {
        setIsInitialized(true);
      }
    }, 1000);

    return () => {
      mounted = false;
    };
  }, []); // Run only once on mount

  if (!isInitialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: 2,
          backgroundColor: 'background.default'
        }}
      >
        <CircularProgress />
        <Box sx={{ 
          color: 'text.secondary',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1
        }}>
          <div>Initializing application...</div>
          <div style={{ fontSize: '0.8em' }}>
            {isAuthenticated ? 'Validating session...' : 'Checking authentication...'}
          </div>
        </Box>
      </Box>
    );
  }

  return <>{children}</>;
};

export default AuthInitializer;
